import React from "react";
import { Row, Col } from "reactstrap";

const SealAndTitle = (props) => {
  return (
    <Row className="pr-0 pl-0">
      <Col xl={12} className="sealAndTitle">
        <img
          src={props.courtSeal}
          alt="United States District Court District of Arizona court seal"
          className="mx-auto d-block courtSeal"
        />
        <h1
          className="text-center"
          style={{ color: "white", textShadow: "2px 2px 4px #000000" }}
        >
          United States District Court District of Arizona
        </h1>
        <h2
          className="text-center"
          style={{ color: "white", textShadow: "2px 2px 4px #000000" }}
        >
          Federal Court Advice-Only Clinic
        </h2>
      </Col>
    </Row>
  );
};
export default SealAndTitle;
